module.exports = __webpack_public_path__ + "img/arrow-front.d8c5abb9.svg";